import React, { useState } from 'react';
import { format, addWeeks, addMonths, startOfWeek } from 'date-fns';
import { ChevronLeftIcon, ChevronRightIcon } from '@heroicons/react/24/solid';

import MonthView from '../components/MonthView';
import WeekView from '../components/WeekView';
import { ResourceBookingSchema } from "../data/types";
import { AddCircle } from '@mui/icons-material';
import { RequestDetailsModal } from "./AppModal";
import NewSearch from './NewSearch';
type CalendarProps = {
    // toggleCalendarView?: React.Dispatch<React.SetStateAction<boolean>>
    bookings: ResourceBookingSchema[]
    handleOpenAddBooking: (resourceId: string) => void
}

const Calendar: React.FC<CalendarProps> = ({bookings, handleOpenAddBooking}) => {
  const [view, setView] = useState<'month' | 'week'>('month');
  const [currentDate, setCurrentDate] = useState<Date>(new Date());
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedBooking, setSelectedBooking] = useState<ResourceBookingSchema | null>(null);

  const handleBookingClick = (booking: ResourceBookingSchema) => {
    setSelectedBooking(booking);
    setIsModalOpen(true);
  };

  const handleCloseModal = () => {
    setIsModalOpen(false);
    setSelectedBooking(null);
  };

  const next = () => {
    setCurrentDate(view === 'month' ? addMonths(currentDate, 1) : addWeeks(currentDate, 1));
  };

  const prev = () => {
    setCurrentDate(view === 'month' ? addMonths(currentDate, -1) : addWeeks(currentDate, -1));
  };

  return (
    <div className="w-full">
      {/* Header */}
      <div className="flex items-center justify-between p-4">
        <div className="flex items-center gap-2">
          
          <span className="font-[18px] font-raleway mr-2">
            {view === 'month'
              ? format(currentDate, 'MMMM yyyy')
              : `${format(startOfWeek(currentDate), 'MMMM d, yyyy')} - ${format(addWeeks(startOfWeek(currentDate), 1), 'MMMM d, yyyy')}`}
          </span>
          <button onClick={prev} className="p-2 hover:bg-gray-100 border-[1px] border-[#E9E9E9] rounded-full">
            <ChevronLeftIcon className="h-5 w-5 text-gray-500" />
          </button>
          <button onClick={next} className="p-2 hover:bg-gray-100 border-[1px] border-[#E9E9E9] rounded-full">
            <ChevronRightIcon className="h-5 w-5 text-gray-500" />
          </button>
        </div>
        <div className="flex items-center gap-2">
          <div className="w-auto">
            <NewSearch searchBoxWidth="w-[300px]" searchType="reservations" searchTerm="" changeSearchTerm={() => {}} />
          </div>
          <div className="w-auto">
            <button className="flex items-center gap-1 bg-primary-200 text-white px-4 py-2 rounded-md shadow hover:bg-primary-300" onClick={() => handleOpenAddBooking(bookings[0]?.resource_id || "")}>
              <AddCircle style={{ fontSize: 15 }} className="mr-1" /> Add a Reservation
            </button>
          </div>
        </div>
      </div>
      {/* Toggle buttons */}
      <div className="flex justify-center gap-0 mb-4 font-raleway">
        <button
          onClick={() => setView('week')}
          className={`px-4 py-2 w-1/6 rounded-l-full rounded-r-none border-[#E9E9E9] border-[1px] transition-colors duration-150  ${view === 'week' ? 'bg-[#E9E9E9] text-black font-bold' : 'bg-white text-[#808080] hover:bg-gray-100'}`}
        >
          Week
        </button>
        <button
          onClick={() => setView('month')}
          className={`px-4 py-2 w-1/6 rounded-l-none rounded-r-full border-[#E9E9E9] border-[1px] transition-colors duration-150 ${view === 'month' ? 'bg-[#E9E9E9] text-black font-bold' : 'bg-white text-[#808080] hover:bg-gray-100'}`}
        >
          Month
        </button>
      </div>
      {/* Calendar view */}
      {view === 'month' ? (
        <MonthView currentDate={currentDate} bookings={bookings} onBookingClick={handleBookingClick} />
      ) : (
        <WeekView currentDate={currentDate} bookings={bookings} onBookingClick={handleBookingClick} />
      )}
      {selectedBooking && (
        <RequestDetailsModal 
          isOpen={isModalOpen}
          request={selectedBooking}
          allResourceRequests={bookings}
          closeAppModal={handleCloseModal}
        />
      )}
    </div>
  );
};

export default Calendar;
